export default "__VITE_ASSET__eae04bd3__"